"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateResponseSchema = exports.CreateRequestSchema = void 0;
const zod_1 = require("zod");
const customer_1 = require("../common/customer");
exports.CreateRequestSchema = zod_1.z.object({
    email: zod_1.z
        .string({ required_error: 'Email is required' })
        .email('Not a valid email'),
    password: zod_1.z
        .string()
        .min(6, { message: 'Password must be 6 or more characters' }),
    name: zod_1.z.string(),
    confirmPassword: zod_1.z.string()
        .min(6, { message: 'Password must be 6 or more characters' }).optional(),
    phone: zod_1.z.string()
});
exports.CreateResponseSchema = zod_1.z.object({
    customer: customer_1.CustomerAttributesFullSchema,
});
//# sourceMappingURL=api.js.map